import { action } from '@sas/nova-commons/action';
import { createReducer } from '../utils/action/createReducer';
const AddRoot = 'layout/AddRoot';
const RemoveRoot = 'layout/RemoveRoot';
export const LayoutRootState = {
    actions: {
        addRoot: (id) => action(AddRoot, id),
        removeRoot: (id) => action(RemoveRoot, id),
    },
    actionTypes: {
        addRoot: AddRoot,
        removeRoot: RemoveRoot,
    },
    reducer: createReducer([], {
        [AddRoot]: (state, action) => {
            if (state.indexOf(action.payload) !== -1) {
                return state;
            }
            return [...state, action.payload];
        },
        [RemoveRoot]: (state, action) => {
            const index = state.indexOf(action.payload);
            if (index === -1) {
                return state;
            }
            const rc = state.concat();
            rc.splice(index, 1);
            return rc;
        },
    }),
};
